import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { onAuthStateChanged } from 'firebase/auth';
import { useDispatch } from 'react-redux';

// Firebase auth and Redux actions
import { auth } from './firebase';
import { fetchUserData, clearUser } from './store/slices/authslice';

// Import your app components
import ComboDeal from './components/ComboDeal';
import HeroSection from './components/HeroSection';
import MenuSection from './components/Menu';
import Navbar from './components/Navbar';
import Cart from './components/Cart';
import Grills_ from './components/Grills_';
import PizzaComponent from './components/Pizza';
import BreakfastComponent from './components/BreakFast';
import SandwichesComponent from './components/Sandwiches';
import Checkout from './components/Checkout';
import Payment from './components/Payment';
import Orders from './components/Orders';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import ExtraSidesComponent from './components/Extrasides';
import Account from './components/Account';
import Pastry from './components/Pastry';
import Smoothies from './components/Smoothies';
import Shawarma from './components/Shawarma';
import Milkshakes from './components/Milkshakes';
import SoftDrinksComponent from './components/Softdrinks';
import HotBeveragesComponent from './components/Hotbeverages';
import SoupComponent from './components/African Dishes';
import SuyaSpotComponent from './components/Suya';
import FishermansDelightComponent from './components/Fishermans Delight';
import PastaComponent from './components/Pasta';
import PepperSoupComponent from './components/Peppersoup';
import SaladComponent from './components/Salad';
import ComboComponent from './components/Combo';
import AboutSection from './components/About';
import NoodlesComponent from './components/Noodles';
import NotFound from './components/NotFound';
import EndlessFoodCarousel from './components/EndlessCarousel';
import FloatingWhatsAppButton from './components/FloatingWhatsappButton';
import HowItWorks from './components/HowitWorks';
import Farm from './components/Farm';
// Removed FarmPopup import

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);
  
  return null;
}

export default function App() {
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // Removed showFarmPopup state

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(fetchUserData(user.uid))
          .finally(() => {
            setAuthChecked(true);
            setIsInitialLoad(false);
            // Removed farm popup code
          });
      } else {
        dispatch(clearUser());
        setAuthChecked(true);
        setIsInitialLoad(false);
        // Removed farm popup code
      }
    });
    return () => unsubscribe();
  }, [dispatch]);

  // Removed closeFarmPopup function

  return (
    <Router>
      <>
        <ScrollToTop />
        <ToastContainer position="top-right" autoClose={1500} />
        <Navbar />
        <FloatingWhatsAppButton />

        {/* Removed Farm Popup component */}

        {/* Main content is always rendered */}
        <Routes>
          <Route
            path="/"
            element={
              <>
                {/* Pass the authChecked flag to HeroSection */}
                <HeroSection startTimer={authChecked} />
                <EndlessFoodCarousel />
                <ComboDeal />
                <HowItWorks />
                <AboutSection />
                <Testimonials />
                <Footer />
              </>
            }
          />
          <Route path="/menu" element={<MenuSection />}>
            <Route path="grills" element={<Grills_ />} />
            <Route path="extra-sides" element={<ExtraSidesComponent />} />
            <Route path="pizza" element={<PizzaComponent />} />
            <Route path="breakfast" element={<BreakfastComponent />} />
            <Route path="pastry" element={<Pastry />} />
            <Route path="smoothies" element={<Smoothies />} />
            <Route path="shawarma" element={<Shawarma />} />
            <Route path="sandwiches" element={<SandwichesComponent />} />
            <Route path="milkshakes" element={<Milkshakes />} />
            <Route path="softdrinks" element={<SoftDrinksComponent />} />
            <Route path="hot-beverages" element={<HotBeveragesComponent />} />
            <Route path="nigerian-soups" element={<SoupComponent />} />
            <Route path="suya" element={<SuyaSpotComponent />} />
            <Route path="fisherman-delight" element={<FishermansDelightComponent />} />
            <Route path="pasta" element={<PastaComponent />} />
            <Route path="peppersoup" element={<PepperSoupComponent />} />
            <Route path="salad" element={<SaladComponent />} />
            <Route path="combo" element={<ComboComponent />} />
            <Route path="noodles" element={<NoodlesComponent />} />
          </Route>
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/account" element={<Account />} />
          <Route path="/farm" element={<Farm />} />
          
          {/* 404 - Not Found Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        {/* Overlay for auth check, shown only on initial load */}
        {(!authChecked && isInitialLoad) && (
          <div className="fixed inset-0 flex items-center justify-center z-50 bg-transparent backdrop-blur-lg">
            <h1 className="text-2xl font-bold text-red-500 animate-pulse">
              TheGrillShack
            </h1>
          </div>
        )}
      </>
    </Router>
  );
}